import { useEffect } from "react";
import { useParams } from "react-router-dom";

const BACKEND_URL = window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || window.location.origin;

/**
 * Public review-redirect landing page.
 *
 * SMS review requests link to a clean, short URL:
 *     https://jobs.screenzz.com/r/{token}
 *
 * That path lands here, and we immediately bounce to the backend's
 * `/api/r/{token}` endpoint which records the click and 302s to the real
 * Google review URL. Two hops, but the customer sees a friendly URL in
 * the SMS instead of one that starts with "/api/".
 */
export default function ReviewRedirect() {
  const { token } = useParams();
  useEffect(() => {
    if (!token) return;
    // Use replace so the customer's back button skips the intermediate
    // hop and returns them to their SMS thread.
    window.location.replace(`${BACKEND_URL}/api/r/${token}`);
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-zinc-500 text-sm">
      Opening your Google review page…
    </div>
  );
}
